// Unified Real-Time Sync Engine for Plotfy
// Broadcasts data mutation events across tabs, windows, and components

const CHANNEL_NAME = 'plotfy_realtime_sync'
let broadcastChannel = null

try {
  if (typeof window !== 'undefined' && 'BroadcastChannel' in window) {
    broadcastChannel = new BroadcastChannel(CHANNEL_NAME)
  }
} catch {
  broadcastChannel = null
}

/**
 * Call this whenever any state mutation occurs (topup, wallet change, validation, withdrawal, campaign status)
 */
export function notifyDataChanged(payload = {}) {
  const detail = {
    timestamp: Date.now(),
    ...payload,
  }

  // 1. Dispatch custom DOM event in the current tab
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('plotfy:data-changed', { detail }))
    window.dispatchEvent(new CustomEvent('plotfy:demo-wallet-changed', { detail }))
  }

  // 2. Broadcast across browser tabs
  if (broadcastChannel) {
    try {
      broadcastChannel.postMessage(detail)
    } catch {
      // Ignore broadcast errors
    }
  }
}

/**
 * Subscribe to real-time data changes across tabs and current window
 */
export function subscribeRealtimeSync(onSync) {
  if (typeof window === 'undefined') return () => {}

  const handleCustomEvent = (event) => {
    onSync(event.detail || {})
  }

  const handleStorageEvent = (event) => {
    if (event.key?.startsWith('plotfy') || event.key === null) {
      onSync({ type: 'storage', key: event.key })
    }
  }

  window.addEventListener('plotfy:data-changed', handleCustomEvent)
  window.addEventListener('plotfy:demo-wallet-changed', handleCustomEvent)
  window.addEventListener('storage', handleStorageEvent)

  let handleBroadcast = null
  if (broadcastChannel) {
    handleBroadcast = (event) => {
      onSync(event.data || {})
    }
    broadcastChannel.addEventListener('message', handleBroadcast)
  }

  return () => {
    window.removeEventListener('plotfy:data-changed', handleCustomEvent)
    window.removeEventListener('plotfy:demo-wallet-changed', handleCustomEvent)
    window.removeEventListener('storage', handleStorageEvent)
    if (broadcastChannel && handleBroadcast) {
      broadcastChannel.removeEventListener('message', handleBroadcast)
    }
  }
}
